<template>
  <el-carousel :interval="5000" trigger="click" class="banner hidden-sm-and-down whitebg" :height="bannerheight+'px'">
    <el-carousel-item v-for="(item,i) in carousel" :key="i" class="bananer">
      <a class="el-carousel__item" :href="item.Url" target="_blank">
        <img :src="Url +item.PictureGUID" style=" width:100%;height:320px;">
        </a>
    </el-carousel-item>
    <!-- <el-carousel-item class="bananer">
      <div class="el-carousel__item">
        <img src="../assets/images/banner.png" style=" width:100%;height:320px;">
        </div>
    </el-carousel-item>
    <el-carousel-item  class="bananer">
      <div class="el-carousel__item">
        <img src="../assets/images/banner.png" style=" width:100%;height:320px;">
        </div>
    </el-carousel-item> -->
  </el-carousel>
</template>
<script>
    export default {
        name: "CommonBanner",
      data() {
        return {
        carousel:"",
        bannerheight:""
		}
      },
	  async created(){
		  let carousel = await this.$store.dispatch("_getBannerList",{ID:1})
      this.carousel = carousel.data.Data
    },
     mounted() {
    this.setSize();
    window.addEventListener(
      "resize",
      () => {
        this.setSize();
      },
      false
    );
  },
  methods:{
     setSize() {
       if(document.body.clientWidth / 4.12<320){
         this.bannerheight = document.body.clientWidth / 4.12;
       }else{
         this.bannerheight =320
       }
      
    }
  }
    }
</script>

<style>


.banner .el-carousel__indicators--horizontal .el-carousel__button {
  width: 10px;
    border-radius: 50%;
    height: 10px;
}

.el-carousel__container{ width: 100% !important; text-align: center;}
.banner_text{
     position: absolute;
    z-index: 99;
    text-align: left;
    bottom: 60px;
    display: flex;
    width: 100%;
}
.banner_p{
  width: 1200px;
  margin: 0 auto;

}
.banner_text p{
  color: #0c4e5e;
  font-size: 16px;
  line-height: 28px;
  text-shadow:1px 0 #fff,0 1px #fff,1px 0 #fff,0 1px #fff;
}
.xingx{
  color: #ff7800;
}
</style>
